/**
 * Organization-related constants
 */

export const ORGANIZATION_CONSTANTS = {
  DEFAULT_ORGANIZATION_ID: 'cb8b8e8a-4a8e-41f8-b3c7-0666c510bae7',
  DEFAULT_ORGANIZATION_NAME: 'Default Organization',
} as const; 